import { TextLegacy } from '@/components/common'
import Table from '@/components/common/table/table'
import { FontResponsiveSizeType } from '@/components/common/texts/TextBase'

const PolicyKcp = ({
  fontSize = { xs: 12, md: 14 },
  marginTop = 10,
}: {
  fontSize?: FontResponsiveSizeType
  marginTop?: number
}) => {
  const columnsPersonalInfo = [
    {
      dataIndex: 'category',
      key: 'category',
      width: '20%',
    },
    {
      dataIndex: 'description',
      key: 'description',
    },
  ]
  const dataSourcePersonalInfo = [
    {
      key: 1,
      category: '가. 통신과금서비스 이용과 관련된 수집 정보',
      description: '-통신사\n' + '-휴대폰번호\n' + '-생년월일\n' + '-성별(내외국인 구분포함)\n' + '-이메일',
    },
    {
      key: 2,
      category: '나. 서비스이용 또는 처리 과정에서 자동 혹은 수동으로 생성되어 수집되는 정보',
      description:
        '- 이용자의 상품 또는 용역관련 거래정보\n' +
        '(주문자명, 주소, 이메일, 회원ID, 상품명, 주문요청금액 등)\n' +
        '- 이용자의 이메일, 접속 IP\n' +
        '- Mac Address/ OS정보 / User_agent (브라우저 정보, 단말기 기종 등)\n' +
        '- 쿠키\n' +
        '- 접속로그\n' +
        '- 불량 혹은 비정상 이용기록\n' +
        '- 이용자 결제정보와 연동되어 생성되는 고유번호\n' +
        '- DI, 통신사 등급, 통신사 가입일, 통신과금서비스 수납방법\n' +
        '- 통신과금서비스 연체금액(*),\n' +
        '- 발생•해소 시기 등 채무불이행 관련 신용도 정보(*)\n' +
        '- 결제사 코드, 실물/컨텐츠 구분\n' +
        '\n' +
        '(*) 표시된 정보는 본 서비스의 원활한 제공을 위한 (이용불가능한 이용자, 불량•불법 이용자의 부정이용 방지를 위한) 필수 수집 항목 입니다.',
    },
  ]

  const columns3rd = [
    {
      title: '제공받는 자',
      dataIndex: 'recipient',
      key: 'recipient',
      width: '22%',
    },
    {
      title: '제공받는 자의 보유 및 이용 목적',
      dataIndex: 'purpose',
      key: 'purpose',
    },
    {
      title: '제공하는 개인(신용) 정보 항목',
      dataIndex: 'info',
      key: 'info',
    },
    {
      title: '제공받는 자의 보유 및 이용기간',
      dataIndex: 'period',
      key: 'period',
    },
  ]
  const dataSource3rd = [
    {
      key: 1,
      recipient:
        '㈜에스케이텔레콤\n' +
        '㈜케이티\n' +
        '㈜엘지유플러스\n' +
        '주식회사 LG헬로비전\n' +
        '㈜한국케이블텔레콤\n' +
        '에스케이텔링크 주식회사\n' +
        '㈜다날\n' +
        '㈜케이지모빌리언스\n' +
        '㈜다우데이타',
      purpose:
        '이용자 본인 인증 및\n' +
        '거래 승인,\n' +
        '이용자의 실시간 미납정보 확인\n' +
        '요금 정산을 위한 거래정보 전송\n' +
        '수납 등 요금 정산 관련 업무',
      info:
        '-주민등록번호 앞7자리(또는 생년월일, 성별, 내외국인 구분)\n' +
        '-휴대전화 또는 유선전화번호\n' +
        '-거래내역\n' +
        '-휴대폰결제 비밀번호\n' +
        '-통신사 등',
      period:
        '-건당 거래금액 1만원 초과의 경우 : 5년\n' +
        '-건당 거래금액 1만원 이하의 경우 : 1년\n' +
        '(단, 관련법령에서 달리 정하고 있는 경우 그에 따름)',
    },
    {
      key: 2,
      recipient: '㈜한국결제인증',
      purpose: '휴대폰안심결제서비스',
      info: '-휴대전화번호',
      period: '서비스 해지 및 서비스안내 종료 시',
    },
    {
      key: 3,
      recipient: '㈜코리아크레딧뷰로',
      purpose: '휴대폰 소액결제 미납채권에 대한 개인신용정보를 제공받기 위한 목적',
      info: '-성명\n' + '-생년월일+성별\n' + '-휴대폰번호\n' + '-DI(Duplication Information)\n' + '-미납정보',
      period:
        '-이용목적 달성 시 또는 서비스 해지 시\n' +
        '-거래가 거절되거나, 제공된 날로부터 동의철회 시 또는 제공된 목적을 달성할 때까지',
    },
    {
      key: 4,
      recipient: '이용자의 거래 상대방',
      purpose: '거래 승인 확인, 취소 및 환불, 거래 대금의 정산, 거래 확인 요청에 대한 응대 및 확인',
      info:
        '-휴대전화 또는 유선 전화번호\n' +
        '-거래 승인 여부\n' +
        '-거래 승인 실패 원인\n' +
        '-결제 한도\n' +
        '-거래 내역 등\n' +
        '-이메일',
      period:
        '-건당 거래금액 1만원 초과의 경우 : 5년\n' +
        '-건당 거래금액 1만원 이하의 경우 : 1년\n' +
        '(단, 관련법령에서 달리 정하고 있는 경우 그에 따름)',
    },
    {
      key: 5,
      recipient: '(사)한국전화결제산업협회 부정거래',
      purpose: '부정거래(스미싱, 휴대폰 현금화 등)의 방지 및 관련 자료 취합, 휴대폰결제 관련 주요 내용 안내',
      info: '휴대전화번호, 통신사 등',
      period:
        '-건당 거래금액 1만원 초과의 경우 : 5년\n' +
        '-건당 거래금액 1만원 이하의 경우 : 1년\n' +
        '(단, 관련법령에서 달리 정하고 있는 경우 그에 따름)',
    },
  ]

  const columnsCreditInquiry = [
    {
      title: '조회목적',
      dataIndex: 'purpose',
      key: 'purpose',
    },
    {
      title: '조회대상기관',
      dataIndex: 'company',
      key: 'company',
    },
    {
      title: '조회 정보',
      dataIndex: 'info',
      key: 'info',
    },
  ]
  const dataSourceCreditInquiry = [
    {
      key: 1,
      purpose: '채무불이행 관련\n' + '신용도 정보 확인',
      company: '코리아크레딧뷰로㈜',
      info: '채무불이행 관련 신용도 정보',
    },
  ]

  const columnsConsignment = [
    {
      title: '수탁사',
      dataIndex: 'trustee',
      key: 'trustee',
    },
    {
      title: '위탁 업무',
      dataIndex: 'work',
      key: 'work',
    },
  ]
  const dataSourceConsignment = [
    {
      key: 1,
      trustee: '㈜고려신용정보',
      work: '이용자 미납 채권 추심',
    },
  ]

  return (
    <div style={{ padding: 10, paddingTop: marginTop }}>
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        {'제1조 (목적)\n' +
          "이 약관은 엔에이치엔한국사이버결제 주식회사(이하 '회사'라 합니다)가 제공하는 전자지급결제대행서비스 및 결제대금예치서비스를 이용자가 이용함에 있어 회사와 이용자 사이의 전자금융거래에 관한 기본적인 사항을 정함을 목적으로 합니다.\n" +
          '\n' +
          '제2조 (용어의 정의)\n' +
          '이 약관에서 정하는 용어의 정의는 다음과 같습니다.\n' +
          '\n' +
          "1. '전자금융거래'라 함은 회사가 전자적 장치를 통하여 전자지급결제대행서비스 및 결제대금예치서비스(이하 '전자금융거래 서비스'라고 합니다)를 제공하고, 이용자가 회사의 종사자와 직접 대면하거나 의사소통을 하지 아니하고 자동화된 방식으로 이를 이용하는 거래를 말합니다.\n" +
          "2. '전자지급결제대행서비스'라 함은 전자적 방법으로 재화의 구입 또는 용역의 이용에 있어서 지급결제정보를 송신하거나 수신하는 것 또는 그 대가의 정산을 대행하거나 매개하는 서비스를 말합니다.\n" +
          "3. '결제대금예치서비스'라 함은 이용자가 재화의 구입 또는 용역의 이용에 있어서 그 대가(이하 '결제대금'이라 한다)의 전부 또는 일부를 재화 또는 용역(이하 '재화 등'이라 합니다)을 공급받기 전에 미리 지급하는 경우, 회사가 이용자의 물품수령 또는 서비스 이용 확인 시점까지 결제대금을 예치하는 서비스를 말합니다.\n" +
          '4. ‘가맹점’이라 함은 금융기관 또는 전자금융업자와의 계약에 따라 직불전자지급수단이나 선불전자지급수단 또는 전자화폐에 의한 거래에 있어서 이용자에게 재화 또는 용역을 제공하는 자로서 금융기관 또는 전자금융업자가 아닌 자를 말합니다.\n' +
          "5. '이용자'라 함은 이 약관에 동의하고 회사가 제공하는 전자금융거래 서비스를 이용하는 자를 말합니다.\n" +
          "6. '접근매체'라 함은 전자금융거래에 있어서 거래지시를 하거나 이용자 및 거래내용의 진실성과 정확성을 확보하기 위하여 사용되는 수단 또는 정보로서 전자식 카드 및 이에 준하는 전자적 정보(신용카드번호를 포함한다), '전자서명법'상의 인증서, 회사에 등록된 이용자번호, 이용자의 생체정보, 이상의 수단이나 정보를 사용하는데 필요한 비밀번호 등 전자금융거래법 제2조 제10호에서 정하고 있는 것을 말합니다.\n" +
          "7. '거래지시'라 함은 이용자가 본 약관에 의하여 체결되는 전자금융거래계약에 따라 회사에 대하여 전자금융거래의 처리를 지시하는 것을 말합니다.\n" +
          "8. '오류'라 함은 이용자의 고의 또는 과실 없이 전자금융거래가 전자금융거래계약 또는 이용자의 거래지시에 따라 이행되지 아니한 경우를 말합니다.\n" +
          '제3조 (약관의 명시 및 변경)\n' +
          '① 회사는 이용자가 전자금융거래 서비스를 이용하기 전에 이 약관을 게시하고 이용자가 이 약관의 중요한 내용을 확인할 수 있도록 합니다.\n' +
          '② 회사는 이용자의 요청이 있는 경우 전자문서의 전송방식에 의하여 본 약관의 사본을 이용자에게 교부합니다.\n' +
          '③ 회사가 약관을 변경하는 때에는 그 시행일 1월 전에 변경되는 약관을 회사가 제공하는 전자금융거래 서비스 이용 초기화면 및 회사의 홈페이지에 게시함으로써 이용자에게 공지합니다. 다만, 법령의 개정으로 인하여 긴급하게 약관을 변경하는 경우에는 즉시 공지합니다.\n' +
          '④ 이용자가 변경된 약관사항에 동의하지 않는 경우에는 서비스의 이용이 불가하며 이용자는 이용 계약을 해지할 수 있습니다.\n' +
          '제4조 (전자지급결제대행서비스의 종류)\n' +
          '회사가 제공하는 전자지급결제대행서비스는 지급결제수단에 따라 다음과 같이 구별됩니다.\n' +
          '\n' +
          '1. 신용카드결제대행서비스: 이용자가 결제대금의 지급을 위하여 제공한 지급결제수단이 신용카드인 경우로서, 회사가 전자결제시스템을 통하여 신용카드 지불정보를 송,수신하고 결제대금의 정산을 대행하거나 매개하는 서비스를 말합니다.\n' +
          '2. 계좌이체대행서비스: 이용자가 결제대금을 회사의 전자결제시스템을 통하여 금융기관에 등록한 자신의 계좌에서 출금하여 원하는 계좌로 이체할 수 있는 실시간 송금 서비스를 말합니다.\n' +
          '3. 가상계좌서비스: 이용자가 결제대금을 현금으로 결제하고자 경우 회사의 전자결제시스템을 통하여 자동으로 이용자만의 고유한 일회용 계좌의 발급을 통하여 결제대금의 지급이 이루어지는 서비스를 말합니다.\n' +
          "4. 기타: 회사가 제공하는 서비스로서 지급결제수단의 종류에 따라 '휴대폰 결제대행서비스', 'ARS결제대행서비스', '상품권결제대행서비스', '교통카드결제대행서비스' 등이 있습니다.\n" +
          '제5조 (결제대금예치서비스의 내용)\n' +
          '① 이용자(이용자의 동의가 있는 경우에는 재화 등을 공급받을 자를 포함합니다. 이하 본조에서 같습니다)는 재화 등을 공급받은 사실을 재화 등을 공급받은 날부터 3영업일 이내에 회사에 통보하여야 합니다.\n' +
          '② 회사는 이용자로부터 재화 등을 공급받은 사실을 통보받은 후 회사와 통신판매업자간 사이에서 정한 기일 내에 통신판매업자에게 결제대금을 지급합니다.\n' +
          '③ 회사는 이용자가 재화 등을 공급받은 날부터 3영업일이 지나도록 정당한 사유의 제시없이 그 공급받은 사실을 회사에 통보하지 아니하는 경우에는 이용자의 동의없이 통신판매업자에게 결제대금을 지급할 수 있습니다.\n' +
          '④ 회사는 통신판매업자에게 결제대금을 지급하기 전에 이용자에게 결제대금을 환급받을 사유가 발생한 경우에는 그 결제대금을 소비자에게 환급합니다.\n' +
          '⑤ 회사는 이용자와의 결제대금예치서비스 이용과 관련된 구체적인 권리,의무를 정하기 위하여 본 약관과는 별도로 결제대금예치서비스이용약관을 제정할 수 있습니다.\n' +
          '제6조 (이용시간)\n' +
          '① 회사는 이용자에게 연중무휴 1일 24시간 전자금융거래 서비스를 제공함을 원칙으로 합니다. 단, 금융기관 기타 결제수단 발행업자의 사정에 따라 달리 정할 수 있습니다.\n' +
          '② 회사는 정보통신설비의 보수, 점검 기타 기술상의 필요나 금융기관 기타 결제수단 발행업자의 사정에 의하여 서비스 중단이 불가피한 경우, 서비스 중단 3일 전까지 게시 가능한 전자적 수단을 통하여 서비스 중단 사실을 게시한 후 서비스를 일시 중단할 수 있습니다. 다만, 시스템 장애복구, 긴급한 프로그램 보수, 외부요인 등 불가피한 경우에는 사전 게시없이 서비스를 중단할 수 있습니다.\n' +
          '제7조 (접근매체의 선정과 사용 및 관리)\n' +
          '① 회사는 전자금융거래 서비스 제공 시 접근매체를 선정하여 이용자의 신원, 권한 및 거래지시의 내용 등을 확인할 수 있습니다.\n' +
          '② 이용자는 접근매체를 제3자에게 대여하거나 사용을 위임하거나 양도 또는 담보 목적으로 제공할 수 없습니다.\n' +
          '③ 이용자는 자신의 접근매체를 제3자에게 누설 또는 노출하거나 방치하여서는 안되며, 접근매체의 도용이나 위조 또는 변조를 방지하기 위하여 충분한 주의를 기울여야 합니다.\n' +
          '④ 회사는 이용자로부터 접근매체의 분실이나 도난 등의 통지를 받은 때에는 그 때부터 제3자가 그 접근매체를 사용함으로 인하여 이용자에게 발생한 손해를 배상할 책임이 있습니다.\n' +
          '제8조 (거래내용의 확인)\n' +
          "① 회사는 이용자와 미리 약정한 전자적 방법을 통하여 이용자의 거래내용(이용자의 '오류정정 요구사실 및 처리결과에 관한 사항'을 포함합니다)을 확인할 수 있도록 하며, 이용자의 요청이 있는 경우에는 요청을 받은 날로부터 2주 이내에 모사전송 등의 방법으로 거래내용에 관한 서면을 교부합니다. 다만, 전자적 장치의 운영 장애, 그 밖의 사유로 거래내용을 제공할 수 없는 때에는 즉시 이용자에게 전자문서 전송(전자우편을 이용한 전송을 포함합니다)의 방법으로 그러한 사유를 알려야 하며, 거래내용을 제공할 수 없는 기간은 서면교부 기간에 산입하지 아니합니다.\n" +
          '② 회사가 이용자에게 제공하는 거래내용 중 거래계좌의 명칭 또는 번호, 거래의 종류 및 금액, 거래상대방을 나타내는 정보, 거래일자, 전자적 장치의 종류 및 전자적 장치를 식별할 수 있는 정보와 해당 전자금융거래와 관련한 전자적 장치의 접속기록 회사가 전자금융거래의 대가로 받은 수수료, 이용자의 출금 동의에 관한 사항, 전자금융거래의 신청 및 조건의 변경에 관한 사항, 건당 거래금액이 1만원을 초과하는 전자금융거래에 관한 기록은 5년간, 건당 거래금액이 1만원 이하인 소액 전자금융거래에 관한 기록, 전자지급수단 이용시 거래승인에 관한 기록, 이용자의 오류정정 요구사실 및 처리결과에 관한 사항은 1년간의 기간을 대상으로 보존하고, 회사가 전자지급결제대행 서비스 제공의 대가로 수취한 수수료에 관한 사항을 제공합니다.\n' +
          '③ 이용자가 제1항에서 정한 서면교부를 요청하고자 할 경우 다음의 주소 및 전화번호로 요청할 수 있습니다.\n' +
          '주소: 서울시 구로구 디지털로 26길 72(구로동, NHN한국사이버결제)\n' +
          '이메일 주소: help@kcp.co.kr\n' +
          '전화번호: 1544-8667\n' +
          '제9조 (오류의 정정 등)\n' +
          '① 이용자는 전자금융거래 서비스를 이용함에 있어 오류가 있음을 안 때에는 회사에 대하여 그 정정을 요구할 수 있습니다.\n' +
          '② 회사는 전항의 규정에 따른 오류의 정정요구를 받은 때 또는 스스로 오류가 있음을 안 때 에는 이를 즉시 조사하여 처리한 후 정정요구를 받은 날 또는 오류가 있음을 안 날부터 2주 이내에 그 결과를 이용자에게 문서, 전화 또는 전자우편으로 알려 드립니다.\n' +
          '제10조 (가맹점의 준수사항 등)\n' +
          '① 가맹점은 직불전자지급수단이나 선불전자지급수단 또는 전자화폐(이하 "전자화폐등"이라 한다)에 의한 거래를 이유로 재화 또는 용역의 제공 등을 거절하거나 이용자를 불리하게 대우하여서는 아니 됩니다.\n' +
          '② 가맹점은 이용자로 하여금 가맹점수수료를 부담하게 하여서는 아니 됩니다.\n' +
          '③ 가맹점은 다음 각 호의 어느 하나에 해당하는 행위를 하여서는 아니 됩니다.\n' +
          '1. 재화 또는 용역의 제공 등이 없이 전자화폐등에 의한 거래를 한 것으로 가장(가장)하는 행위\n' +
          '2. 실제 매출금액을 초과하여 전자화폐등에 의한 거래를 하는 행위\n' +
          '3. 다른 가맹점 이름으로 전자화폐등에 의한 거래를 하는 행위\n' +
          '4. 가맹점의 이름을 타인에게 빌려주는 행위\n' +
          '5. 전자화폐등에 의한 거래를 대행하는 행위\n' +
          '④ 가맹점이 아닌 자는 가맹점의 이름으로 전자화폐등에 의한 거래를 하여서는 아니 됩니다.\n' +
          '제11조 (가맹점 모집 등)\n' +
          '① 회사는 가맹점을 모집하는 경우에는 가맹점이 되고자 하는 자의 영업여부 등을 확인하여야 합니다. 다만, 「여신전문금융업법」 제16조의2의 규정에 따라 이미 확인을 한 가맹점인 경우에는 그러하지 아니합니다.\n' +
          '② 회사는 다음 각 호의 사항을 금융위원회가 정하는 방법에 따라 가맹점에 알려야 합니다.\n' +
          '1. 가맹점수수료\n' +
          '2. 제2항의 규정에 따른 가맹점에 대한 책임\n' +
          '3. 전조 규정에 따른 가맹점의 준수사항\n' +
          '③ 회사는 가맹점이 전조의 규정을 위반하여 형의 선고를 받거나 관계 행정기관으로부터 위반사실에 대하여 서면통보를 받는 등 대통령령이 정하는 사유에 해당하는 때에는 특별한 사유가 없는 한 지체 없이 가맹점계약을 해지하여야 합니다. ‘대통령령이 정하는 사유’라 함은 다음 각 호의 어느 하나에 해당하는 경우를 말합니다.\n' +
          '1. 가맹점이 전자금융거래법 제 26조 또는 전조 제3항 제3호 내지 제5호를 위반하여 형을 선고받은 경우\n' +
          '2. 가맹점이 전조 제1항, 제2항 또는 제3항 제3호 내지 제5호를 위반한 사실에 관하여 관계 행정기관으로부터 서면통보가 있는 경우\n' +
          '3. 관계 행정기관으로부터 해당 가맹점의 폐업사실을 서면으로 통보 받은 경우\n' +
          '제12조 (회사의 책임)\n' +
          '① 접근매체의 위조나 변조로 발생한 사고로 인하여 이용자에게 발생한 손해에 대하여 배상책임이 있습니다. 다만 이용자가 제7조 제2항에 위반하거나 제3자가 권한 없이 이용자의 접근매체를 이용하여 전자금융거래를 할 수 있음을 알았거나 알 수 있었음에도 불구하고 이용자가 자신의 접근매체를 누설 또는 노출하거나 방치한 경우 그 책임의 전부 또는 일부를 이용자가 부담하게 할 수 있습니다.\n' +
          "② 회사는 계약체결 또는 거래지시의 전자적 전송이나 처리과정에서 발생한 사고로 인하여 이용자에게 그 손해가 발생한 경우에는 그 손해를 배상할 책임이 있습니다. 다만 본조 제1항 단서에 해당하거나 법인('중소기업기본법' 제2조 제2항에 의한 소기업을 제외합니다)인 이용자에게 손해가 발생한 경우로서 회사가 사고를 방지하기 위하여 보안절차를 수립하고 이를 철저히 준수하는 등 합리적으로 요구되는 충분한 주의의무를 다한 경우에는 그러하지 아니합니다.\n" +
          '③ 회사는 이용자로부터의 거래지시가 있음에도 불구하고 천재지변, 회사의 귀책사유가 없는 정전, 화재, 통신장애 기타의 불가항력적인 사유로 처리 불가능하거나 지연된 경우로서 이용자에게 처리 불가능 또는 지연사유를 통지한 경우(금융기관 또는 결제수단 발행업체나 통신판매업자가 통지한 경우를 포함합니다)에는 이용자에 대하여 이로 인한 책임을 지지 아니합니다.\n' +
          '④ 회사는 전자금융거래를 위한 전자적 장치 또는 ‘정보통신망 이용촉진 및 정보보호 등에 관한 법률’ 제 2조 제 1항 제 1호에 따른 정보통신망에 침입하여 거짓이나 그 밖의 부정한 방법으로 획득한 접근매체의 이용으로 발생한 사고로 인하여 이용자에게 그 손해가 발생한 경우에는 그 손해를 배상할 책임이 있습니다. 다만, 다음과 같은 경우 회사는 이용자에 대하여 일부 또는 전부에 대하여 책임을 지지 않습니다.\n' +
          '1. 회사가 접근매체에 따른 확인 외에 보안강화를 위하여 전자금융거래 시 요구하는 추가적인 보안조치를 이용자가 정당한 사유 없이 거부하여 전자금융거래법 제9조 제1항 제3호에 따른(이하 ‘사고’라 한다)사고가 발생한 경우.\n' +
          '2. 이용자가 동항 제 1호의 추가적인 보안조치에서 사용되는 매체, 수단 또는 정보에 대하여 다음과 같은 행위를 하여 사고가 발생하는 경우\n' +
          '가. 누설, 누출 또는 방치한 행위\n' +
          '나. 제 3자에게 대여하거나 그 사용을 위임한 행위 또는 양도나 담보의 목적으로 제공한 행위\n' +
          '제13조 (전자지급거래계약의 효력)\n' +
          '① 회사는 이용자의 거래지시가 전자지급거래에 관한 경우 그 지급절차를 대행하며, 전자지급거래에 관한 거래지시의 내용을 전송하여 지급이 이루어지도록 합니다.\n' +
          '② 회사는 이용자의 전자지급거래에 관한 거래지시에 따라 지급거래가 이루어지지 않은 경우 수령한 자금을 이용자에게 반환하여야 합니다.\n' +
          '제14조 (거래지시의 철회)\n' +
          '① 이용자는 전자지급거래에 관한 거래지시의 경우 지급의 효력이 발생하기 전까지 다음의 주소, 전자우편 및 연락처에 연락을 취함으로써 거래지시를 철회할 수 있습니다.\n' +
          '주소: 서울시 구로구 디지털로26길 72(구로동, NHN한국사이버결제)\n' +
          '이메일 주소: help@kcp.co.kr\n' +
          '전화번호: 1544-8667\n' +
          '② 전항의 지급의 효력이 발생 시점이란 (i) 전자자금이체의 경우에는 거래지시된 금액의 정보에 대하여 수취인의 계좌가 개설되어 있는 금융기관의 계좌 원장에 입금기록이 끝난 때 (ii) 그 밖의 전자지급수단으로 지급하는 경우에는 거래지시된 금액의 정보가 수취인의 계좌가 개설되어 있는 금융기관의 전자적 장치에 입력이 끝난 때를 말합니다.\n' +
          '③ 이용자는 지급의 효력이 발생한 경우에는 전자상거래 등에서의 소비자보호에 관한 법률 등 관련 법령상 청약의 철회의 방법 또는 본 약관 제5조에서 정한 바에 따라 결제대금을 반환받을 수 있습니다.\n' +
          '제15조 (전자지급결제대행 서비스 이용 기록의 생성 및 보존)\n' +
          '① 회사는 이용자가 전자금융거래의 내용을 추적, 검색하거나 그 내용에 오류가 발생한 경우에 이를 확인하거나 정정할 수 있는 기록을 생성하여 보존합니다.\n' +
          '② 전항의 규정에 따라 회사가 보존하여야 하는 기록의 종류 및 보존방법은 제8조 제2항에서 정한 바에 따릅니다.\n' +
          '제16조 (전자금융거래정보의 제공금지)\n' +
          '회사는 전자금융거래 서비스를 제공함에 있어서 취득한 이용자의 인적사항, 이용자의 계좌, 접근매체 및 전자금융거래의 내용과 실적에 관한 정보 또는 자료를 이용자의 동의를 얻지 아니하고 제3자에게 제공, 누설하거나 업무상 목적 외에 사용하지 아니합니다. 단, 통신비밀보호법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률 등 관계법령에 의하여 적법한 절차에 따르는 경우에는 그러하지 아니합니다.\n' +
          '\n' +
          '제17조 (계약해지 및 이용제한)\n' +
          '① 이용자는 서비스 홈페이지 또는 고객센터를 통하여 서비스 계약을 해지할 수 있습니다.\n' +
          '② 회사는 이용자가 본 약관의 의무를 이행하지 않을 경우 사전 통지 없이 즉시 서비스 이용계약을 해지하거나 서비스 이용을 제한할 수 있습니다. 회사의 조치에 대하여 이의가 있는 경우에는 서비스 홈페이지 또는 고객센터를 통하여 이의신청을 할 수 있습니다.\n' +
          '③ 전 항의 이의가 정당하다고 판단되는 경우 회사는 서비스의 이용을 즉시 재개합니다.\n' +
          '제18조 (분쟁처리 및 분쟁조정)\n' +
          '① 이용자는 다음의 분쟁처리 책임자 및 담당자에 대하여 전자금융거래 서비스 이용과 관련한 의견 및 불만의 제기, 손해배상의 청구 등의 분쟁처리를 요구할 수 있습니다.\n' +
          '담당자: RM팀\n' +
          '연락처(전화번호, 전자우편주소) : 070-5075-8041, minwon@kcp.co.kr\n' +
          '② 이용자가 회사에 대하여 분쟁처리를 신청한 경우에는 회사는 15일 이내에 이에 대한 조사 또는 처리 결과를 이용자에게 안내합니다.\n' +
          "③ 이용자는 '금융위원회의 설치 등에 관한 법률' 제51조의 규정에 따른 금융감독원의 금융분쟁조정위원회나 '소비자기본법' 제33조의 규정에 따른 한국소비자원에 회사의 전자금융거래 서비스의 이용과 관련한 분쟁조정을 신청할 수 있습니다.\n" +
          '제19조 (회사의 안정성 확보 의무)\n' +
          '회사는 전자금융거래가 안전하게 처리될 수 있도록 선량한 관리자로서의 주의를 다하며 전자금융거래의 안전성과 신뢰성을 확보할 수 있도록 전자금융거래의 종류별로 전자적 전송이나 처리를 위한 인력, 시설, 전자적 장치 등의 정보기술부문 및 전자금융업무에 관하여 금융위원회가 정하는 기준을 준수합니다.\n' +
          '\n' +
          '제20조 (약관 외 준칙 및 관할)\n' +
          '① 회사와 이용자 사이에 개별적으로 합의한 사항이 이 약관에 정한 사항과 다를 때에는 그 합의사항을 이 약관에 우선하여 적용합니다.\n' +
          '② 이 약관에서 정하지 아니한 사항에 대하여는 전자금융거래법, 전자상거래 등에서의 소비자 보호에 관한 법률, 통신판매에 관한 법률, 여신전문금융업법 등 소비자보호 관련 법령에서 정한 바에 따릅니다.\n' +
          '③ 회사와 이용자간에 발생한 분쟁에 관한 관할은 민사소송법에서 정한 바에 따릅니다.\n' +
          '\n' +
          '\n' +
          '부칙 <제 1 호, 2006.12.26.>\n' +
          '본 약관은 2007년 1월 1일부터 시행한다.\n' +
          '\n' +
          '부칙 <제 2 호, 2011.01.17.>\n' +
          '본 약관은 2011년 02월 21일부터 시행한다.\n' +
          '(제 2조 4항 신설, 제 8조 2항 일부 개정, 제 10조 신설, 제11조 신설)\n' +
          '\n' +
          '부칙 <제 3 호, 2015.10.14.>\n' +
          '본 약관은 2015 10월 14일부터 시행한다.\n' +
          '(제 17조 제1항 일부 개정, 제 12조 제 5항 신설)\n' +
          '\n' +
          '부칙 <제 4 호, 2016.04.08.>\n' +
          '본 약관은 2016년 4월 26일부터 시행한다.\n' +
          '(제 1조 일부 개정, 제 8조 제 3항 일부 개정)\n' +
          '\n' +
          '부칙 <제 5 호, 2016.11.11.>\n' +
          '본 약관은 2016 11월 21일부터 시행한다.\n' +
          '(제 17조 신설, 제3조 제3항 및 제4항, 제9조 제2항, 제14조 제1항, 제16조, 제18조 제3항 일부 개정)\n' +
          '\n' +
          '부칙 <제 6 호, 2016.11.28.>\n' +
          '본 약관은 2016 11월 28일부터 시행한다.\n' +
          '(제12조 제1항 삭제, 제6조 제2항, 제8조 제1항 및 제2항, 제9조 제2항, 제19조 개정, 제20조 제1항 신설)\n' +
          '\n' +
          '부칙 <제 7 호, 2018.01.19.>\n' +
          '본 약관은 2018년 02월 22일부터 시행한다.\n' +
          '(제12조 제1항, 제2항 일부 개정)\n' +
          '\n' +
          '부칙 <제 8 호, 2018.07.23.>\n' +
          '본 약관은 2018년 07월 31일부터 시행한다.\n' +
          '(제18조 제1항 일부 개정)\n' +
          '\n' +
          '부칙 <제 9 호, 2018.11.15.>\n' +
          '본 약관은 2018년 12월 20일부터 시행한다.\n' +
          '(제8조 제3항, 제14조 제1항 개정)\n' +
          '\n' +
          '부칙 <제 10 호, 2019.05.21.>\n' +
          '본 약관은 2019년5월 31일부터 시행한다.\n' +
          '(제8조 제3항, 제14조 제1항 개정)\n' +
          '\n' +
          '통신과금서비스 이용약관\n' +
          '제1조 (목적)\n' +
          '이 약관은 통신과금서비스를 제공하는 엔에이치엔한국사이버결제 주식회사(이하 “회사”라 합니다)와 통신과금서비스이용자(이하 “이용자”라 합니다) 사이의 통신과금서비스에 관한 기본적인 사항을 정함으로써 통신과금서비스의 안정성과 신뢰성을 확보함에 그 목적이 있습니다.\n' +
          '\n' +
          '제2조 (용어의 정의)\n' +
          '이 약관에서 정하는 용어의 정의는 다음과 같습니다.\n' +
          '\n' +
          '① “통신과금서비스”라 함은 정보통신서비스로서 다음 각 호의 업무를 말합니다.\n' +
          '1. 타인이 판매, 제공하는 재화 또는 용역(이하 “재화 등”이라 한다)의 대가를 자신이 제공하는 전기통신역무의 요금과 함께 청구, 징수하는 업무\n' +
          '2. 타인이 판매, 제공하는 재화 등의 대가가 제1호의 업무를 제공하는 자의 전기통신역무의 요금과 함께 청구, 징수되도록 거래정보를 전자적으로 송수신하는 것 또는 그 대가의 정산을 대행하거나 매개하는 업무\n' +
          '② “이용자”라 함은 이 약관에 동의하고 회사가 제공하는 통신과금서비스를 이용하는 자를 말합니다.\n' +
          '③ “접근매체”라 함은 통신과금 거래에 있어서 거래지시를 하거나 이용자 및 거래내용의 진실성과 정확성을 확보하기 위하여 사용되는 수단 또는 정보로서 유무선 전화 및 통신사에 등록된 이용자의 유무선 전화 번호, 이용자의 생체정보, 등록된 이용자번호, 이용자 결제정보와 연동되어 생성되는 고유번호(이하 ‘고유번호’), 카드, 이상의 수단이나 정보를 사용하는데 필요한 비밀번호 등을 말합니다.\n' +
          '④ “가맹점” 또는 “거래상대방”이라 함은 통신과금서비스를 통하여 그 대가를 받고 이용자에게 재화 또는 용역을 판매, 제공하는 자를 말합니다.\n' +
          '⑤ “거래지시”라 함은 이용자가 통신과금서비스계약에 따라 회사에게 통신과금서비스의 처리를 지시하는 것을 말하며, 아래의 경우 거래지시가 있는 것으로 봅니다.\n' +
          '1. 이용자가 결제창에 인증번호, 고유식별정보 등을 입력하고 동 약관에 동의하는 경우\n' +
          '2. 이용자가 “제4조의 2”에 따라 등록된 접근매체를 사용하여 결제를 요청하는 경우\n' +
          '⑥ “지정한 기일”이란 이용자가 통신사와 약정한 1항의 전기통신역무의 요금 납입기한을 의미하며, 이는 이동통신사의 기준에 따릅니다.\n' +
          '⑦ “월 자동결제서비스”라 함은 이용자의 동의를 받아 첫 구매 이후 재화 및 용역의 이용기간이 자동으로 연장되어 그 대가가 이용자에게 매월 자동 청구되는 상품을 말합니다.\n' +
          '⑧ “결제간소화 서비스”란 이용자의 최초 1회 결제 시 이용자의 결제정보(통신사, 유무선전화번호, 생년월일, 성별 등)와 연동된 고유번호를 생성하고, 생성된 고유번호를 활용하여 이용자가 인증만으로 간편하게 계속적으로 결제를 할 수 있는 통신과금서비스를 말합니다.\n' +
          '⑨ “휴대폰 간편결제”란 이용자가 휴대폰 단말기 등 각종 유무선 기기를 통하여 자신의 정보를 입력하여 본 서비스 등록 후에는 고유번호, 휴대폰번호와 비밀번호 또는 비밀번호의 입력만으로 결제를 요청할 수 있는 서비스를 말합니다.\n' +
          '⑩ “익월 취소 기능”이란 이용자가 휴대폰결제를 이용하여 완료한 결제 건을 결제한 당월 이후에도 취소할 수 있도록 하는 서비스를 말합니다.\n' +
          '제3조 (약관의 명시 및 변경)\n' +
          '① 회사는 이용자가 통신과금서비스를 이용하기 전에 이 약관을 게시하고 이용자가 이 약관의 중요한 내용을 확인할 수 있도록 합니다.\n' +
          '② 회사는 이용자의 요청이 있는 경우 전자문서의 전송방식에 의하여 본 약관의 사본을 이용자에게 교부합니다.\n' +
          '③ 회사가 약관을 변경하는 때에는 그 시행일 1 개월 전에 변경되는 약관을 회사의 홈페이지에 게시함으로써 이용자에게 공지합니다.\n' +
          '제4조 (접근매체의 관리 및 이용자의 의무)\n' +
          '① 회사는 통신과금서비스 제공 시 접근매체를 선정하여 이용자의 신원, 권한 및 거래지시의 내용 등을 확인할 수 있습니다.\n' +
          '② 이용자는 접근매체를 제3자에게 대여하거나 사용을 위임하거나 양도 또는 담보 목적으로 제공할 수 없습니다.\n' +
          '③ 이용자는 자신의 접근매체를 제3자에게 누설 또는 노출하거나 방치하여서는 안 되며, 접근매체의 도용이나 위조 또는 변조를 방지하기 위하여 충분한 주의를 기울여야 합니다.\n' +
          '④ 회사는 이용자로부터 접근매체의 분실이나 도난 등의 통지를 받은 때에는 그 때부터 제3자가 그 접근매체를 사용함으로 인하여 이용자에게 발생한 손해를 배상할 책임이 있습니다.\n' +
          '⑤ 아래의 어느 하나에 행위를 통하여 자금을 융통하여 주거나 이를 알선ㆍ중개ㆍ권유ㆍ광고하는 경우 회사는 정보통신망 이용촉진 및 정보보호 등에 관한 법률 제72조에 의거하여 관계당국에 고소 및 고발, 민사상의 법적 조치를 취할 수 있습니다.\n' +
          '가. 재화등의 판매ㆍ제공을 가장하거나 실제 매출금액을 초과하여 통신과금서비스에 의한 거래를 하거나 이를 대행하게 하는 행위\n' +
          '나. 통신과금서비스 이용자로 하여금 통신과금서비스에 의하여 재화등을 구매ㆍ이용하도록 한 후 통신과금서비스 이용자가 구매ㆍ이용한 재화등을 할인하여 매입하는 행위\n' +
          '⑥ 회사는 본 서비스(휴대폰 소액결제 서비스)의 원활한 이용을 위해 고객인증, 이용금액 청구 및 수납을 위하여 이용자가 지정한 이동통신사에 고객의 휴대전화번호, 생년월일, 성별 등 개인정보와 인증 및 과금에 필요한 정보(사용금액, 구매일시, 상품코드 등)를 제공할 수 있습니다.\n' +
          '⑦ 이동통신사와의 청구수납대행계약에 따른 요금정산을 위해 필요한 정보(휴대전화번호, 생년월일, 성별, 사용일자, 청구일자, 청구 및 수납금액 등)를 제공받을 수 있습니다.\n' +
          '제4조의 2 (특정 접근매체를 이용한 거래에 대한 특칙)\n' +
          '① 회사는 통신과금서비스 제공 시 이용자의 신청에 의하여 이용자에게 필요결제정보와 연동된 이용자고유번호 또는 이용자고유번호에 접근할 수 있는 수단을 부여할 수 있습니다.\n' +
          '② 이용자가 회사에 대하여 별도의 이용자고유번호 또는 이용자고유번호에 접근할 수 있는 수단의 부여를 신청하는 경우 회사는 이용자가 제공한 아래 각 호의 정보 등을 이용자의 동의를 받고 저장합니다.\n' +
          '1. 이용자의 주민등록번호 또는 이를 대체할 수 있는 본인 확인 정보\n' +
          '2. 이용자가 가입한 통신사\n' +
          '3. 이용자의 유무선 전화 번호\n' +
          '4. 이용자가 설정한 비밀번호\n' +
          '5. 기타 통신과금서비스에 필요한 정보\n' +
          '③ 이용자가 필요 결제정보와 연동된 이용자고유번호 또는 이용자고유번호에 접근할 수 있는 수단을 이용하여 통신과금서비스를 재이용할 경우, 회사는 전항의 저장된 이용자가 설정한 비밀번호 또는 개인정보 일부를 이용자에게 확인을 받고 거래의 승인 여부를 결정할 수 있습니다.\n' +
          '④ 이용자가 이용자고유번호 또는 이용자고유번호에 접근할 수 있는 수단을 부여 받아 회사가 제공하는 결제 방법에 의하여 결제를 진행하고자 하는 경우, 본 약관에 대한 1회의 동의로 향후 결제 이용 시 본 약관의 내용이 자동으로 적용됩니다.\n' +
          '⑤ 이용자는 제13조의 방법으로 저장된 개인정보의 삭제를 회사에 요청할 수 있고, 회사는 이용자의 요청을 받은 즉시, 이용자의 개인정보를 삭제하여야 합니다. 단, 제11조 제2항의 사항은 거래내용 확인을 위해 삭제할 수 없습니다.\n' +
          '제4조의 3 (결제 간소화 서비스의 제공)\n' +
          '① 회사는 이용자의 동의 또는 신청에 의하여 결제 간소화 서비스 제공을 위해 이용자에게 결제정보와 연동된 이용자의 고유번호 등을 부여할 수 있습니다.\n' +
          '② 이용자가 최초 1회 결제정보를 등록하여 결제가 된 이후에는 결제정보 입력 없이 회사는 부여한 고유번호 등을 이용하여 인증만으로 거래 승인여부를 결정할 수 있습니다.\n' +
          '제 4조의 4 (월 자동결제서비스의 제공)\n' +
          '① 회사는 이용자가 월 자동결제서비스를 이용할 경우에는 전자적 대금 결제창에서 이용금액 및 매월 자동 결제된다는 내용에 체크하는 방법 등으로 명시적 동의를 받습니다.\n' +
          '② 월 자동결제서비스를 제공하는 동안 이용금액을 증액할 경우에는 전항의 동의를 받을 때 또는 이용금액이 증액되기 전에 이용자가 전자적 대금 결제창에서 이용금액 증액에 관한 내용에 체크하는 방법 등으로 명시적 동의를 받습니다.\n' +
          '③ 제 2항에 따라 이용금액이 증액될 경우 회사는 이용자에게 이용금액 변경사실을 단문메세지(SMS)등을 통하여 사전에 통지하며, 이용금액이 증액될 때마다 재동의를 받습니다.\n' +
          '④ 회사가 월 자동결제서비스를 제공하는 동안 가맹점(콘텐츠제공사업자)의 영업양도, 양수 또는 합병 발생 시 이용자에 대한 전월 자동결제 내역이 존재하거나 당월에 월 자동결제 동의 내역이 존재하는 경우에만 월 자동결제서비스를 제공합니다.\n' +
          '⑤ 이용자는 원할 경우 월 자동결제서비스를 차단할 수 있으며, 본 약관 제 15조에서 정하는 방법으로 신청할 수 있습니다.\n' +
          '제4조의 5 (익월 취소 기능 제공)\n' +
          '① 회사는 이용자의 요청 시 휴대폰결제를 이용한 달의 다음 달 이후에도 결제 취소 기능을 제공할 수 있습니다. 단, 익월결제취소는 이용자가 사용중인 통신사가 해당 기능을 제공하는 경우에 한하여 가능합니다.\n' +
          '② 일부 가맹점의 경우, 재화 등의 특성상 익월결제취소 기능이 제공되지 않을 수 있으며, 통신사 및 회사의 정책에 따라 익월결제취소 기능 제공이 가능한 가맹점은 달라질 수 있습니다.\n' +
          '③ 익월결제취소 요청에 따라 발생한 반환 예정 대금은 통신사의 정책에 따라 이용자의 청구 금액에서 상계처리 됩니다. 단, 반환 대금이 향후 청구금액보다 많을 경우 잔여 반환 대금은 그 이후 청구대금에서 순차적으로 상계 처리합니다.\n' +
          '⑤ 익월결제취소는 이용자의 필요 또는 요청에 의해 제공되는 것이므로 반환대금에 대한 이자는 가산되지 않습니다.\n' +
          '제5조 (모니터링 및 해킹방지 시스템 구축)\n' +
          '① 회사는 서버 및 통신기기의 정상작동여부 확인을 위하여 정보처리시스템 자원 상태의 감시, 경고 및 제어가 가능한 모니터링체계를 갖추어야 하며, 정보통신망 이용촉진 및 정보보호 등에 관한 법률 및 그 시행령에 따른 통신과금서비스의 안전성, 신뢰성 확보를 위한 필요조치를 준수합니다.\n' +
          '② 회사는 해킹 침해 방지를 위하여 다음 각 호의 시스템 및 프로그램을 설치하여야 합니다.\n' +
          '1. 침입차단시스템 설치\n' +
          '2. 침입탐지시스템 설치\n' +
          '3. 그 밖에 필요한 보호장비 또는 암호프로그램 등 정보보호시스템 설치\n' +
          '제6조 (바이러스 감염 방지)\n' +
          '회회사는 컴퓨터바이러스 감염을 방지하기 위하여 다음 각 호를 포함한 대책을 수립, 운용하여야 합니다.\n' +
          '\n' +
          '1. 출처, 유통경로 및 제작자가 명확하지 아니한 응용프로그램은 사용을 자제하고 불가피할 경우에는 컴퓨터바이러스 검색프로그램으로 진단 및 치료 후 사용할 것\n' +
          '2. 컴퓨터바이러스 검색, 치료 프로그램을 설치하고 최신 버전을 유지할 것\n' +
          '3. 컴퓨터바이러스 감염에 대비하여 방어, 탐색 및 복구 절차를 마련할 것\n' +
          '제7조 (비정상거래 및 위험거래 차단 시스템 구축)\n' +
          '① 회사는 비정상거래(스미싱, 개인정보 도용 시도로 의심되는 일정 금액 이상 일정 횟수 이상 결제 시도 등을 고려하여 비정상거래여부 판단) 및 위험거래(환금성이 있어 스미싱, 개인정보 도용에 이용되기 쉬운 서비스의 금액 및 횟수 고려하여 위험거래여부 판단)로 발생하는 제3자의 결제로부터 선량한 이용자를 보호하고, 이로 인한 이용자의 손해를 최소화하기 위해 다음 각 호와 같은 시스템을 구축하여야 합니다.\n' +
          '1. 비정상 거래 유형 분석 시스템\n' +
          '2. 복제폰 이용 거래 탐지 시스템\n' +
          '3. 기타 불법결제 의심 거래 모니터링 시스템\n' +
          '② 회사는 본조 제1항 각 호의 시스템을 통해 비정상거래 또는 위험거래에 따른 결제 요청으로 판단될 경우, 결제 요청을 제한 또는 차단할 수 있습니다.\n' +
          '③ 본조 제2항에 의해 결제 요청이 제한 또는 차단된 경우, 이용자는 제15조 제1항의 담당자에게 연락을 하여 본인 확인 절차를 거친 후 통신과금서비스를 이용할 수 있습니다.\n' +
          '제8조 (이용자의 정보보호)\n' +
          '① 회사는 이용자의 과실 또는 이용자 장비의 문제로 인해 회사의 정보통신망에 중대한 침해사고가 발생하여 회사의 서비스를 이용하는 이용자의 정보시스템 또는 정보통신망 등에 심각한 장애가 발생할 가능성이 있는 아래 각 호의 경우에는 이용자에 대한 보호조치를 전자우편, 공지사항 등의 방법으로 요청할 수 있습니다.\n' +
          '1. 이용자의 장비가 제3의 사용자에게 이용 당하여 회사의 서비스에 장애를 초래한 경우\n' +
          '2. 이용자의 장비의 H/W 혹은 S/W의 문제로 회사의 서비스에 장애를 초래하는 경우\n' +
          '3. 이용자가 고의 혹은 실수로 회사의 악의적인 접속을 시도하거나 접속을 한 경우\n' +
          '② 이용자가 취할 보호조치의 내용은 아래 각 호와 같습니다.\n' +
          '1. 해당 장비의 네트워크로부터 연결케이블 제거, 서비스 포트 차단, 네트워크 주소 차단 등의 즉각적인 분리\n' +
          '2. 해당 장비에 대한 보안점검\n' +
          '3. 관련 원인점검 및 패치, OS재설치, 필터링 등의 사후 보안 조치 실시\n' +
          '③ 회사는 이용자가 전항의 보호조치를 이행하지 아니할 경우 정보통신망으로의 접속을 5일간 제한 할 수 있습니다.\n' +
          '④ 회사가 이용자의 보호조치 불이행에 대하여 부당한 접속 제한을 한 경우 이용자는 제15조 제1항의 담당자에게 이의제기를 할 수 있으며, 회사는 이의제기를 접수 후 2주 이내로 사실을 확인하고, 이용자에게 서면 (전자문서 포함) 으로 답변을 발송하여야 합니다.\n' +
          '제9조 (회사의 권리와 의무)\n' +
          '① 회사가 접근매체의 발급주체가 아닌 경우에는 접근매체의 위조나 변조로 발생한 사고로 인하여 이용자에게 발생한 손해에 대하여 배상책임이 없습니다.\n' +
          '② 회사가 접근매체의 발급주체이거나 사용, 관리주체인 경우에는 접근매체의 위조나 변조로 발생한 사고로 인하여 이용자에게 발생한 손해에 대하여 배상책임이 있습니다. 단, 사고발생에 있어서 이용자의 고의나 중대한 과실이 있는 경우로서 전부 또는 일부를 이용자의 부담으로 할 것을 약정한 경우에는 그 책임의 전부 또는 일부를 이용자가 부담하게 할 수 있습니다.(2013.07.17 단서신설)\n' +
          "③ 회사는 계약체결 또는 거래지시의 전자적 전송이나 처리과정에서 발생한 사고로 인하여 이용자에게 손해가 발생한 경우에는 그 손해를 배상할 책임이 있습니다. 다만, 본조 제2항 단서에 해당하거나 법인('중소기업기본법' 제2조 제2항에 의한 소기업을 제외한다)인 이용자에게 손해가 발생한 경우로서 회사가 사고를 방지하기 위하여 보안절차를 수립하고 이를 철저히 준수하는 등 합리적으로 요구되는 충분한 주의의무를 다한 경우에는 그러하지 아니합니다.\n" +
          '④ 회사는 이용자가 통신과금서비스 이용 시 이용약관이나 안내사항 등을 확인하지 않아 발생한 손해, 또는 이용자가 제4조 제2항에 위반하거나 제3자가 권한 없이 이용자의 접근매체를 이용하여 통신과금서비스를 이용할 수 있음을 알았거나 알 수 있었음에도 불구하고 이용자가 자신의 접근매체를 누설 또는 노출하거나 방치하여 발생한 손해 등 이용자의 부주의에 기한 손해에 대하여 배상 책임이 없습니다.\n' +
          '⑤ 회사와 이용자 사이에 손해배상에 관한 협의가 성립되지 아니하거나 협의를 할 수 없는 경우에는 당사자는 방송통신위원회에 재정을 신청할 수 있습니다.\n' +
          '⑥ 회사는 이용자에게 거래 금액 외에 일정금액의 수수료를 건당 부과할 수 있습니다.\n' +
          '⑦ 회사는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 통신과금서비스의 제공을 일시적으로 중단할 수 있습니다.\n' +
          '⑧ 회사는 전항의 사유로 통신과금서비스의 제공이 일시적으로 중단됨으로 인하여 이용자가 입은 손해에 대하여 배상합니다. 단, 회사가 고의 또는 과실이 없음을 입증한 경우에는 그러하지 아니합니다.\n' +
          '⑨ 회사는 이용자가 전기통신역무의 요금과 함께 청구된 재화 등의 대가를 통신사가 지정한 기일까지 납입하지 아니한 때에는 그 청구된 재화 등의 대가의 1000분의 35에 상당하는 가산금을 부과하며, 그 다음 납입 기일까지도 납입하지 아니한 때에는 청구된 재화 등의 대가의 1000분의 40 에 상당하는 가산금을 부과합니다. 단, 본 규정에 의한 가산금은 요금의 납기일이 속한 말일 다음 영업일을 기준으로 하여 체납된 요금에 가산하여 부과합니다.\n' +
          '⑩ 회사는 통신사로부터 통신과금서비스와 관련된 이용자의 개인정보를 제공받을 수 있으며, 회사는 위 제공받은 정보를 통신과금서비스 외의 목적으로 사용할 수 없습니다.\n' +
          "⑪ 회사는 회사가 수립한 정책에 따라, 이용한도금액을 변경할 수 있으며, 복제폰, 대포폰, 휴대폰 소액대출(일명 '휴대폰깡'), 명의도용 등과 같은 시장질서 교란행위로 인한 피해를 방지하기 위하여 결제한도를 일정 기간 동안 일정 금액으로 제한할 수 있습니다.\n" +
          '⑫ 회사는 정보통신망 이용촉진 및 정보보호 등에 관한 법률 및 전자상거래 등에서의 소비자보호 등에 관한 법률에 따라 방송통신위원회와 (사)한국전화결제산업협회에서 마련한 가이드라인에 따른 결제창을 이용자에게 제공하여 전자적 대금지급 시 고지 의무를 강화하고 안정한 결제 환경 조성 등 이용자 보호를 위해 노력합니다.\n' +
          '⑬ 회사는 이용자의 청약의사가 진정한 의사 표시에 의한 것인지를 확인하기 위하여 다음 각 호의 사항에 대하여 명확히 고지하고, 고지한 사항에 대한 이용자의 확인절차를 마련합니다.\n' +
          '1. 재화 또는 용역의 내용 및 종류\n' +
          '2. 재화 또는 용역의 가격\n' +
          '3. 재화 또는 용역의 제공기간\n' +
          '⑭ 회사는 정보통신망 이용촉진 및 정보보호 등에 관한 법률 제61조에 따라 과학기술정보통신부에서 아래 각 호에 해당하는 자에 대해 명한 통신과금서비스 제공의 거부, 정지 또는 제한 명령을 성실히 준수합니다.\n' +
          '1. 청소년보호법 제16조를 위반하여 청소년유해매체물을 청소년에게 판매, 대여, 제공하는 자\n' +
          '2. 다음 어느 하나에 해당하는 수단을 이용하여 이용자로 하여금 재화 등을 구매, 이용하게 함으로써 이용자의 이익을 현저하게 저해하는 자\n' +
          '가. 정보통신망 이용촉진 및 정보보호 등에 관한 법률 제50조를 위반한 영리목적의 광고성 정보 전송\n' +
          '나. 이용자에 대한 기망 또는 부당한 유인\n' +
          '3. 정보통신망 이용촉진 및 정보보호 등에 관한 법률 또는 다른 법률에서 금지하는 재화 등을 판매, 제공하는 자\n' +
          '⑮ 회사는 이용자가 통신사를 통하여 결제비밀번호를 설정할 경우 해당 결제비밀번호가 입력되어야만 결제가 진행되도록 기술적 조치를 취하여야 합니다.\n' +
          '제9조의 2 (재화 등의 공급계약상 대금채권의 채권자)\n' +
          '① 이용자가 재화 등의 대금을 통신사에 휴대폰 이용요금과 함께 납부하기 이전에 회사가 재화 등의 대금를 가맹점에게 선지급한 경우, 이 선지급 대상인 재화 등에 관한 공급계약(이용자는 회사의 고객센터를 통해서 이용자가 거래한 가맹점이 해당 거래의 대상인 재화 등의 대가를 회사로부터 선지급 받는지 여부를 확인하실 수 있습니다)과 관련하여 이용자와 해당 가맹점이 체결한 해당 재화 등의 공급계약상 대금채권의 채권자가 회사임을 해당 가맹점을 대신하여 알려드리며, 이용자는 이에 동의합니다.\n' +
          '② 이용자 및 회사는 회사가 제1항의 재화 등의 공급계약상 대금채권의 채권자가 되는 것에 동의합니다. 단, 제1항의 재화 등의 대금은 통신사의 휴대폰 이용요금 청구시 함께 청구될 예정이며, 이용자가 휴대폰 요금과 함께 위 재화 등의 대금을 통신사에 납부할 경우 회사는 이용자가 회사에 대하여 위 대금채무를 이행한 것으로 보게 됨을 알려드립니다.\n' +
          '제10조 (고지사항)\n' +
          '① 회사는 재화 등의 판매·제공의 대가를 청구할 때 이용자에게 다음 각 호의 사항을 고지하여야 합니다.\n' +
          '1. 통신과금서비스 이용일시\n' +
          '2. 통신과금서비스를 통한 구매·이용의 거래 상대방(통신과금서비스를 이용하여 그 대가를 받고 재화 또는 용역을 판매,제공하는 자를 말하며, 이하 “거래 상대방”이라 합니다)의 상호와 연락처\n' +
          '3. 통신과금서비스를 통한 구매·이용 금액과 그 명세\n' +
          '4. 이의신청 방법 및 연락처\n' +
          '② 회사는 전자적 대금지급이 이루어진 경우에는 전화, 팩스, 휴대전화 등을 이용하여 이용자에게 신속하게 전자적 대금지급 사실을 알립니다.\n' +
          '제11조 (거래내용의 확인)\n' +
          '① 회사는 이용자가 구매ㆍ이용 내역을 확인할 수 있는 방법을 제공하여야 하며, 이용자가 구매ㆍ이용 내역에 관한 서면(전자문서를 포함한다. 이하 같다)을 요청하는 경우에는 그 요청을 받은 날부터 2주 이내에 이를 제공하여야 합니다.\n' +
          '② 회사는 다음 각 호의 사항에 관한 기록을 해당 거래를 한 날부터 1년간 보존하여야 합니다. 다만, 건당 거래 금액이 1만원을 초과하는 거래인 경우에는 5년간 보존하여야 합니다.\n' +
          '\n' +
          '1. 통신과금서비스를 이용한 거래의 종류\n' +
          '\n' +
          '2. 거래 금액\n' +
          '\n' +
          '3. 거래 상대방\n' +
          '\n' +
          '4. 거래 일시\n' +
          '\n' +
          '5. 대금을 청구·징수하는 전기통신역무의 가입자번호\n' +
          '\n' +
          '6. 회사가 통신과금서비스 제공의 대가로 수취한 수수료에 관한 사항\n' +
          '\n' +
          '7. 해당 거래와 관련한 전기통신역무의 접속에 관한 사항\n' +
          '\n' +
          '8. 거래의 신청 및 조건의 변경에 관한 사항\n' +
          '\n' +
          '9. 거래의 승인에 관한 사항\n' +
          '\n' +
          '10.그 밖에 과학기술정보통신부장관이 정하여 고시하는 사항\n' +
          '\n' +
          '③ 전항에 따른 거래기록은 서면, 마이크로필름, 디스크, 자기테이프, 그 밖의 전산정보처리조직에 의하여 보존하여야 합니다. 다만, 디스크, 자기테이프, 그 밖의 전산정보처리조직에 의하여 보존하는 경우에는 전자문서 및 전자거래기본법 제5조 제1항 각 호의 요건을 모두 갖추어야 합니다.\n' +
          '④ 이용자가 제1항에서 정한 서면교부를 요청하고자 할 경우 다음의 주소 및 전화번호로 요청할 수 있습니다.\n' +
          '주소: 서울시 구로구 디지털로26길 72(구로동, NHN한국사이버결제)\n' +
          '이메일 주소: help@kcp.co.kr\n' +
          '전화번호: 1688-6410\n' +
          '제12조 (정정 요구)\n' +
          '이용자는 통신과금서비스가 자신의 의사에 반하여 제공되었음을 안 때에는 회사에게 이에 대한 정정을 요구할 수 있으며(이용자의 고의 또는 중과실이 있는 경우는 제외한다), 회사는 그 정정 요구를 받은 날부터 2주 이내에 처리 결과를 알려 주어야 한다.\n' +
          '\n' +
          '제13조 (개인정보의 보호)\n' +
          '① 회사는 개인정보보법 등 관계 법령이 정하는 바에 따라 이용자의 개인정보를 보호합니다. 회사는 다음과 같이 이용자의 개인정보를 수집 및 이용하거나 제3자에게 제공, 조회, 위탁합니다.\n' +
          ': 개인정보의 수집 및 이용과 관련된 사항\n' +
          '1.개인(신용)정보의 수집 및 이용목적\n' +
          '회사는 다음과 같은 목적 하에 통신과금서비스와 관련한 개인(신용)정보를 수집합니다\n' +
          '\n' +
          '① 이용자가 구매한 재화나 용역의 대금 결제\n' +
          '② 이용자가 결제한 거래의 취소 또는 환불\n' +
          '③ 이용자가 결제한 거래의 청구 및 수납\n' +
          '④ 이용자가 수납한 거래 대금의 정산\n' +
          '⑤ 이용자가 결제한 거래의 내역을 요청하는 경우 응대 및 확인\n' +
          '⑥ 통신과금서비스 이용 불가능한 이용자(미성년자 등)와 불량, 불법 이용자의 부정 이용 방지\n' +
          '⑦ 이용자의 결제 간소화를 위한 고유번호 생성\n' +
          '⑧ 이용자의 결제 대금 미납시 채권보존을 위한 신용보험 가입\n' +
          '⑨ 이용자의 결제 대금 미납시 채권의 회수\n' +
          '⑩ 채무불이행 관련 개인(신용) 정보 확인\n' +
          '⑪ 이용자의 불만사항 해결 및 민원처리, 고지사항 전달\n' +
          '\n' +
          '2. 개인(신용)정보의 수집항목(필수)'}
      </TextLegacy>
      <Table data={dataSourcePersonalInfo} columns={columnsPersonalInfo} style={{ paddingBottom: 10 }} />
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        {'3. 개인(신용)정보의 보유 및 이용기간\n' +
          '이용자의 개인(신용)정보는 원칙적으로 개인정보의 수집 및 이용목적이 달성되면 지체 없이 파기 합니다. 단, 다음의 정보에 대해서는 아래의 이유로 명시한 기간 동안 보존 합니다.\n' +
          '\n' +
          '\n' +
          '가. 회사 내부 방침의 의한 정보보유\n' +
          '[부정이용방지와 비인가사용방지를 위한 결제 이용에 관한 기록]\n' +
          '-보존기간 : 5년\n' +
          '\n' +
          '나. 관련법령에 의한 정보보유\n' +
          '정보통신망 이용촉진 및 정보보호 등에 관한 법률, 상법, 전자상거래 등에서의 소비자보호에 관한 법률 등 관련법령의 규정에 의하여 보존할 필요가 있는 경우 회사는 관련법령에서 정한 일정한 기간 동안 정보를 보관합니다. 이 경우 회사는 보관하는 정보를 그 보관의 목적으로만 이용하며 보존기간은 아래와 같습니다.\n' +
          '\n' +
          '[통신과금서비스에 관련 기록]\n' +
          '-보존기간 : 건당 거래금액 1만원 초과의 경우 5년, 건당 거래금액 1만원 이하의 경우 1년\n' +
          '-보존근거 : 정보통신망 이용촉진 및 정보보호 등에 관한 법률\n' +
          '(* 통신과금서비스 연체금액, 발생•해소 시기 등 채무불이행 관련 신용도 정보는 수령한 날로부터 3년)\n' +
          '\n' +
          '[계약 또는 청약철회 등에 관한 기록]\n' +
          '-보존기간: 5년\n' +
          '-보존근거: 전자상거래 등에서의 소비자보호에 관한 법률\n' +
          '\n' +
          '[대금결제 및 재화 등의 공급에 관한 기록]\n' +
          '-보존기간: 5년\n' +
          '-보존근거: 전자상거래 등에서의 소비자보호에 관한 법률\n' +
          '\n' +
          '[소비자의 불만 또는 분쟁처리에 관한 기록]\n' +
          '-보존기간: 3년\n' +
          '-보존근거: 전자상거래 등에서의 소비자보호에 관한 법률\n' +
          '\n' +
          '[신용정보의 수집 및 이용 등에 관한 기록]\n' +
          '-보존기간: 5년\n' +
          '-보존근거: 신용정보의 이용 및 보호에 관한 법률\n' +
          '\n' +
          '[신용정보 업무처리에 관한 기록]\n' +
          '-보존기간 : 3년\n' +
          '-보존근거 : 신용정보의 이용 및 보호에 관한 법률\n' +
          '\n' +
          '[방문에 관한 기록]\n' +
          '-보존기간: 3개월\n' +
          '-보존근거: 통신비밀보호법\n' +
          '\n' +
          ': 개인정보의 제3자 제공, 조회, 위탁과 관련된 사항\n' +
          '1. 개인(신용)정보의 제3자 제공'}
      </TextLegacy>
      <Table data={dataSource3rd} columns={columns3rd} style={{ paddingBottom: 10 }} />
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        {'2. 개인(신용)정보의 조회'}
      </TextLegacy>
      <Table data={dataSourceCreditInquiry} columns={columnsCreditInquiry} style={{ paddingBottom: 10 }} />
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        {'* 상기 신용정보 조회는 이용자(고객)의 신용등급에 아무런 영향을 미치지 않습니다.\n' +
          '\n' +
          '3. 개인(신용)정보의 처리위탁'}
      </TextLegacy>
      <Table data={dataSourceConsignment} columns={columnsConsignment} style={{ paddingBottom: 10 }} />
      <TextLegacy size={fontSize} style={{ display: 'inline' }}>
        {"② 회사는 '개인정보의 제공,조회 및 처리위탁에 대한 동의'를 '개인정보의 수집, 이용에 대한 동의'와 구분하여 동의를 받으며, 이에 대하여 이용자가 동의를 하지 아니한다는 이유로 회사는 서비스 제공을 거부하지 않습니다. 다만, 이용자가 개인정보의 수집, 이용에 대한 동의, 개인정보의 제공,조회 및 처리위탁에 대한 동의를 거부할 경우 통신과금서비스를 통한 결제가 정상적으로 완료될 수 없습니다.\n" +
          '③ 개인정보의 보유, 이용 기간이 만료된 개인정보는 아래와 같은 방법으로 파기합니다.\n' +
          '1.전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.\n' +
          '2.종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각을 통하여 파기합니다.\n' +
          '④ 이용자는 회사의 개인정보 수집 및 이용 동의를 거부할 수 있습니다. 단, 동의를 거부 하는 경우 결제가 정상적으로 완료 될 수 없음을 알려 드립니다.\n' +
          '제14조 (통신과금정보의 제공금지)\n' +
          '① 회사는 통신과금서비스를 제공함에 있어서 취득한 이용자의 인적사항, 이용자의 계좌, 접근매체 및 통신과금의 내용과 실적에 관한 정보 또는 자료를 이용자의 동의를 얻지 아니하고 제3자에게 제공, 누설하거나 업무상 목적 외에 사용하지 아니합니다. 단, 서비스의 제공에 관한 계약을 이행하기 위하여 필요하여 이용자 정보를 제3자에게 위탁할 경우, 본 약관 또는 홈페이지를 통해 공개하거나 전자우편, 서면, 모사전송, 전화 또는 이와 유사한 방법 중 어느 하나의 방법으로 이용자에게 알립니다.\n' +
          '② 회사는 정보통신망 이용촉진 및 정보보호 등에 관한 법률 (제7장 통신과금서비스)의 관련규정에 의거하여 구성된 “(사)한국전화결제산업협회”가 이용자 보호를 위해 통신과금서비스 관련 정보를 요청하면 다음 각 호의 경우에는 관련 정보를 제공할 수 있습니다.\n' +
          '1.휴대폰깡, 대포폰, 복제폰 등 시장 질서를 교란시키는 불법업체 혹은 불법행위자에 의한 민원발생의 경우\n' +
          '2.지인 사용 등 제3자 결제로 인한 민원발생의 경우\n' +
          '3.기타 통신과금서비스를 통한 불법행위가 발생하여 이용자 보호가 필요한 경우\n' +
          '제15조 (이의신청 및 권리구제)\n' +
          '① 이용자는 다음의 보호책임자 및 담당자에 대하여 이의신청 및 권리구제를 요청할 수 있습니다.\n' +
          '보호책임자 : RM팀 팀장\n' +
          '연락처(전화번호, 전자우편주소): 1688-6410, minwon@kcp.co.kr\n' +
          '보호담당자 : RM팀 해당 업무담당자\n' +
          '연락처(전화번호, 전자우편주소) : 1688-6410, minwon@kcp.co.kr\n' +
          '② 이용자는 서면(전자문서를 포함한다), 전화, 모사전송 등을 통하여 회사에게 통신과금서비스와 관련된 이의신청을 할 수 있습니다.\n' +
          '③ 회사는 본조 제2항에 따른 이의신청을 받은 날부터 2주일 이내에 그 조사 또는 처리 결과를 이용자에게 알려야 합니다.\n' +
          '④ 회사는 이용자와 거래 상대방 사이에 전자적 대금지급과 관련하여 다툼이 있는 경우 이용자나 거래 상대방이 분쟁해결을 위하여 분쟁발생 사실을 소명하여 요청하는 경우 분쟁해결에 필요한 범위 내에서 다음 각 호의 사항에 대하여 지체 없이 협조합니다.\n' +
          '1. 분쟁의 원인이 된 대금지급과 관련된 정보(이용자 인증 관련 정보를 포함합니다)의 열람, 복사 허용\n' +
          '2. 분쟁의 원인이 된 대금지급에 대한 회사의 보안유지 조치관련 정보의 열람, 복사 허용. 단, 공개할 경우 보안유지에 장애가 발생할 우려가 있는 정보에 대해서는 공개를 거부할 수 있습니다.\n' +
          '제16조 ((사)한국전화결제산업협회)\n' +
          '① 회사는 불법 과금, 복제폰, 휴대폰 깡 및 불법 마케팅 등으로부터 이용자를 보호하기 위하여 (사)한국전화결제산업협회(이하 “전결협”이라 한다)의 구성원으로 참여하여, “유무선전화결제이용자보호합의서”를 성실히 이행합니다.\n' +
          '② 회사는 전결협의 민원경보시스템 운영을 위해 항시 연락 가능한 담당자 1인을 아래와 같이 지정하여, 신속한 민원처리에 협조합니다.\n' +
          '- 고객서비스담당부서 : 고객센터\n' +
          '- 전화번호 : 1688-6410\n' +
          '- 이메일 : crm@kcp.co.kr\n' +
          '③ 회사는 전결협 운영위에서 심사하고, 전결협, 방송통신위원회에서 제시한 가이드라인을 준수하며, 가맹점에게 가이드라인의 준수를 권고하고 지속적으로 모니터링 합니다.\n' +
          '제17조 (회사의 안정성 확보 의무)\n' +
          '회사는 통신과금서비스의 안전성과 신뢰성을 확보할 수 있도록 통신과금서비스의 종류별로 전자적 전송이나 처리를 위한 인력, 시설, 전자적 장치 등의 정보기술부문 및 통신과금업무에 관하여 과학기술정보통신부장관이 정하는 기준을 준수합니다.\n' +
          '\n' +
          '제18조 (개인정보 유출등의 통지, 신고)\n' +
          '① 회사는 개인정보의 분실, 도난, 유출(이하 “유출 등”이라 합니다) 사실을 안 때에는 지체 없이 다음 각 호의 모든 사항을 전자우편, 서면, 모사전송, 전화 또는 이와 유사한 방법 중 어느 하나의 방법으로 해당 이용자에게 알리고 방송통신위원회에 신고합니다. 다만, 이용자의 연락처를 알 수 없는 등 정당한 사유가 있는 경우에는 인터넷 홈페이지에 30일 이상 게시함으로써 통지를 갈음 할 수 있습니다.\n' +
          '1. 유출 등이 된 개인정보 항목\n' +
          '2. 유출 등이 발생한 시점\n' +
          '3. 이용자가 취할 수 있는 조치\n' +
          '4. 회사의 대응 조치\n' +
          '5. 이용자가 상담 등을 접수할 수 있는 부서 및 연락처\n' +
          '② 회사는 개인정보의 유출 등에 대한 대책을 마련하고 그 피해를 최소화할 수 있는 조치를 강구하여야 합니다.\n' +
          '제19조 (약관외 준칙 및 관할)\n' +
          '① 이 약관에서 정하지 아니한 사항에 대하여는 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 전자금융거래법, 전자상거래 등에서의 소비자 보호에 관한 법률, 통신판매에 관한 법률, 여신전문금융업법 등 소비자보호 관련 법령에서 정한 바에 따릅니다.\n' +
          '② 회사와 이용자간에 발생한 분쟁에 관한 관할은 민사소송법에서 정한 바에 따릅니다.\n' +
          '\n' +
          '부칙 <제 1 호, 2012.03.19.>\n' +
          '본 약관은 2012년 04월 19일부터 시행한다.\n' +
          '(제 9조 개정)\n' +
          '\n' +
          '부칙 <제2호, 2012.10.20.>\n' +
          '제1조 시행일\n' +
          '본 약관은 2012년 10월 20일부터 시행한다.\n' +
          '\n' +
          '제2조 개정 사항\n' +
          '\n' +
          '1. 제1조 중 “과”를 “와”로 한다.\n' +
          '2. 제2조제1항 중 “각 목”을 “각 호”로, 제2조제1항 제2호 중 “가목”을 “제1호”로 하고 제2조제6항 신설 한다.\n' +
          '3. 제3조제3항 중 “4주”를 “2주”로 하고, “지급결제정보 입력화면 및”을 삭제 한다.\n' +
          '4. 제4조의1(특정 접근매체를 이용한 거래에 대한 특칙)을 신설 한다.\n' +
          '5. 제7조제3항 중 “제14조제1항”을 “제15조제1항”으로 한다.\n' +
          '6. 제8조제1항 중 “회사는”을 “회사는 이용자의 과실 또는 이용자 장비의 문제로 인해 회사의”로, 제8조제4항 중 “제14조제1항”을 “제15조제1항”으로 한다.\n' +
          '7. 제9조제9항 중 “100분의 2”를 “100분의 5”로 하고, 제9조제11항부터 제9조제13항까지를 각각 신설 한다.\n' +
          '8. 제10조제2항을 신설 한다.\n' +
          '9. 제13조 조문의 “13조”를 “14조”로 한다.\n' +
          '10.제13조(개인정보의 보호) 신설 한다.\n' +
          '11.제14조 조문의 “14조”를 “15조”로, 제14조제1항의 보호책임자 “정승규 이사”를 “김용성 차장”으로 한다.\n' +
          '12.제15조 조문의 “15조”를 “16조”로 하고, 제2항의 담당자 “정승규 이사”를 “김용성 차장”으로 한다.\n' +
          '13.제16조 조문의 “16조”를 “17조”로 한다.\n' +
          '14.제18조(개인정보의 누출 등의 통지, 신고)를 신설 한다.\n' +
          '15.제17조 조문의 “17조”를 “19조”로 한다.\n' +
          '부칙 <제3호, 2013.07.22.>\n' +
          '제1조 시행일\n' +
          '본 약관은 2013년07월 22일부터 시행한다.\n' +
          '\n' +
          '제2조 개정 사항\n' +
          '\n' +
          '1. 제7조 제3항 중 “제1항”을 “제2항”으로 한다.\n' +
          '2. 제8조 제1항 각 호의 “사용자”를 “이용자”로 한다.\n' +
          '3. 제9조 제2항 단서를 신설한다.\n' +
          '4. 제9조 제9항 중 “100분의 5에 상당하는”을 “100분의 3”으로 한다.\n' +
          '5. 제9조 제 13항 중 “방송통신위원회”를 “미래창조과학부”로 한다.\n' +
          '6. 제11조 제2항 제 10호 중 “방송통신위원회가”를 “미래창조과학부장관이”로 한다.\n' +
          '7. 제11조 제3항 중 “전자거래기본법”을 “전자문서 및 전자거래기본법”으로 한다.\n' +
          '8. 제14조 제2항 중 “유무선전화결제이용자보호협의회”를 “(사)한국전화결제산업협회”로 한다.\n' +
          '9. 제15조 제1항 중 “김용성 차장”을 “김명건 과장”으로, “help@kcp.co.kr”을 “minwon@kcp.co.kr”로 한다.\n' +
          '10.제 16조 제 1항 중 “유무선전화결제이용자보호협의회(이하 “전보협”이라 한다)를 “(사)한국전화결제산업협회(이하 “전결협”이라 한다)로 한다.\n' +
          '11.제 16조 제 2항 및 제 3항 중 “전보협”을 “전결협”으로 한다.\n' +
          '12.제17조 중 “방송통신위원회가”를 “미래창조과학부장관이”로 한다.\n' +
          '부칙 <제4호, 2015.01.22.>\n' +
          '제 1조 시행일\n' +
          '본 약관은 2015년 02월 02일부터 시행한다.\n' +
          '\n' +
          '제 2조 개정사항\n' +
          '\n' +
          '1. 제 3조 제 3항의 “2주”를 “1개월”로 한다.\n' +
          '2. 제 4조 제 7항의 “주민번호”를 “생년월일, 성별”로 한다.\n' +
          '3. 제 4조 제 8항의 “주민번호”를 “생년월일, 성별”로 한다.\n' +
          '4. 제 13조 제 2항 제 2호의 “주민등록번호”를 “생년월일, 성별”로 한다.\n' +
          '5. 제 15조 제 1항 보호담당자를 “임기훈 사원”으로 한다.\n' +
          '부칙 <제5호, 2015.03.02>\n' +
          '제 1조 시행일\n' +
          '본 약관은 2015년 04월 01일부터 시행한다.\n' +
          '\n' +
          '제 2조 개정사항\n' +
          '\n' +
          '1. 제 2조 제 7항을 신설한다.\n' +
          '2. 제 4조의 2를 신설한다.\n' +
          '부칙 <제6호, 2016.04.12>\n' +
          '제 1조 시행일\n' +
          '본 약관은 2016년 04월 26일부터 시행한다.\n' +
          '\n' +
          '제 2조 개정사항\n' +
          '\n' +
          '1. 제1조의 ‘한국사이버결제 주식회사’를 ‘엔에이치엔한국사이버결제 주식회사’로 한다.\n' +
          '부칙 <제7호, 2016.07.13>\n' +
          '제 1조 시행일\n' +
          '본 약관은 2016년 09월 01일부터 시행한다.\n' +
          '\n' +
          '제 2조 개정사항\n' +
          '\n' +
          '1. 제13조의 ‘개인정보 취급위탁’을 ‘개인정보 처리위탁’으로 한다.\n' +
          '2. 제13조 제1항 제6호를 삭제한다.\n' +
          '3. 제18조의 ‘누출’을 ‘유출’로 한다.\n' +
          '부칙 <제8호, 2017.09.25>\n' +
          '제 1조 시행일\n' +
          '본 약관은 2017년9월 25일부터 시행한다.\n' +
          '\n' +
          '제 2조 개정 사항\n' +
          '\n' +
          '1. 제9조 제 13항 중 "미래창조과학부"를 "과학기술정보통신부"로 한다.\n' +
          '2. 제11조 제2항 제 10호 중 "미래창조과학부장관이"를 "과학기술정보통신부장관이"로 한다.\n' +
          '3. 제17조 중 "미래창조과학부장관이"를 "과학기술정보통신부장관이"로 한다.\n' +
          '부칙 <제9호, 2018.7.23>\n' +
          '제 1조 시행일\n' +
          '본 약관은 2018년7월 31일부터 시행한다.\n' +
          '\n' +
          '제 2조 개정 사항\n' +
          '\n' +
          '1. 제15조 제1항 중 “김명건 과장”을 “RM팀 팀장”으로, “임기훈 사원”을 “RM팀 해당 업무담당자”로 한다.\n' +
          '2. 제16조 제2항 중 “김용성 차장” 을 “모바일사업팀 해당 업무담당자”로 한다.\n' +
          '부칙 <제 10호, 2018.11.19>\n' +
          '제 1조 시행일\n' +
          '본 약관은 2018년 12월 20일부터 시행한다.\n' +
          '\n' +
          '제 2조 개정 사항\n' +
          '\n' +
          '1. 제 2조 제7항 “월 자동결제서비스”를 신설한다.\n' +
          '2. 제 4조의 3 “월 자동결제서비스의 제공”을 신설한다.\n' +
          '3. 제 9조 제 9항 가산금 부과 수수료를 추가 변경한다.\n' +
          '4. 제 9조 제 11항을 신설한다.\n' +
          '5. 제 11조 제 4항 주소를 “서울시 구로구 디지털로26길 72(구로동, NHN한국사이버결제)”로 한다.\n' +
          '6. 제13조 제3항 제1호 가목의 “1) 개인정보 제공 받는 자”에 “별정통신사”를 추가한다.\n' +
          '7. 제13조 제3항 제2호 가목의 “1) 개인정보 위탁 받는 자”에 “별정통신사”를 추가한다.\n' +
          '부칙 <제 11호, 2019.06.27>\n' +
          '제 1조 시행일\n' +
          '본 약관은 2019년 8월 1일부터 시행한다.\n' +
          '\n' +
          '제 2조 개정 사항\n' +
          '\n' +
          '1. 제 9조 제 9항 가산금 부과 수수료를 변경한다.\n' +
          '2. 제 9조의 2를 신설한다.\n' +
          '부칙 <제 12호, 2021.09.08>\n' +
          '제 1조 시행일\n' +
          '본 약관은 2021년 10월 15일부터 시행한다.\n' +
          '\n' +
          '제 2조 개정 사항\n' +
          '\n' +
          '1. 제2조, 제4조, 제4조의4(종전 규정 제4조의3), 제5조, 제7조, 제9조, 제13조, 제14조, 제16조, 제18조를 변경한다.\n' +
          '2. 종전 제9조의 2를 제4조의5로 조항이동 한다.\n' +
          '3. 제2조 제9항, 제2조 제10항, 제9조 제15항, 제9조의 2(재화 등의 공급계약상 대금채권의 채권자)를 신설한다.'}
      </TextLegacy>
    </div>
  )
}

export default PolicyKcp
